export default "__VITE_ASSET__DdAUauDi__"